import React from "react";
import "./loader.css";

function Loader() {
  return (
    <div className="loader-div">
      <div className="loader-inner-div">
        <div class="custom-loader"></div>
      </div>
    </div>
  );
}

export default Loader;
